import gql from "graphql-tag";

const buddyProfileQuery = gql`
    query MentorProfileQuery($id: String, $marketplaceSlug: String) {
        publicMentor(id: $id) {
            id
            active
            firstName
            lastName
            profilePhoto
            lastSeen
            degree {
                id
                name
            }
            degreeLevel
            placeName
            country {
                id
                code
            }
            languages {
                id
                name
            }
            year
            favouriteModules {
                id
                name
            }
            pastQualification
            interests {
                id
                name
            }
            societies {
                id
                name
            }
            bio
            university {
                id
                name
                widgetUrl
                logo
                slug
            }
            shareUrl(marketplaceSlug: $marketplaceSlug)
            mentorFields {
                primaryFlag {
                    name
                    code
                }
                secondaryFlag {
                    name
                    code
                }
            }
        }
    }
`;

export default buddyProfileQuery;
